import { FC, JSX } from 'react';

import { Flex } from 'antd';

import DatePickerFormItem from '@/components/form/form-items/default-items/date-picker-form-item/DatePickerFormItem';

import useIsMobile from '@/hooks/useIsMobile';

import { DEFAULT_DATE_UAS_FORMAT_MOBILE } from '@/constants/defaultDateFormat';

import styles from './DebtsBusinessInfo.module.scss';

export const DebtsBusinessInfo: FC = (): JSX.Element => {
	const isMobile = useIsMobile();
	const inputSize = isMobile ? 'small' : 'middle';

	const metadata = sessionStorage.getItem('metadata');
	const decodedMetadata = metadata ? atob(metadata) : '||';

	const [decodedBusinessName, decodedDoingBusinessAs] = decodedMetadata.split('||');
	const businessName =
		!decodedBusinessName || decodedBusinessName === 'null' ? 'N/A' : decodedBusinessName;
	const doingBusinessAs =
		!decodedDoingBusinessAs || decodedDoingBusinessAs === 'null' ? 'N/A' : decodedDoingBusinessAs;

	return (
		<Flex className={styles['container']}>
			<Flex className={styles['item']} gap={18} vertical>
				<span className={styles['label']}>Business Name</span>
				<span className={styles['value']}>{businessName}</span>
			</Flex>
			<Flex className={styles['item']} gap={18} vertical>
				<span className={styles['label']}>Doing Business As</span>
				<span className={styles['value']}>{doingBusinessAs}</span>
			</Flex>
			<Flex className={styles['item']}>
				<DatePickerFormItem
					datePickerProps={{
						placeholder: ' ',
						allowClear: false,
						format: DEFAULT_DATE_UAS_FORMAT_MOBILE,
						size: inputSize,
						variant: 'underlined',
					}}
					label={<span className={styles['label']}>As of Date*</span>}
					name="asOfDate"
				/>
			</Flex>
		</Flex>
	);
};
